import { Api } from "@core/api/api";
import { trackDraftToDto, TrackDto, trackFromDto } from "./dtos";
import { Track, TrackDraft } from "./track";

const TRACK_URL = "/tracks";

export class TrackApi {
	constructor(private readonly api: Api) {}

	async get(id: string): Promise<Track> {
		const result = await this.api.get<TrackDto>(`${TRACK_URL}/${id}`);
		return trackFromDto(result.data);
	}

	async save(draft: TrackDraft, id: string): Promise<Track> {
		const result = await this.api.put<TrackDto>(`${TRACK_URL}/${id}`, trackDraftToDto(draft));
		return trackFromDto(result.data);
	}

	async delete(id: string): Promise<void> {
		return this.api.delete(`${TRACK_URL}/${id}`);
	}
}
